//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { KinesisContainer, KinesisElement } from "vue-kinesis";
import BannerTypeProduct from "~/components/content-elements/banner-type-product";
export default {
  data() {
    return {
      perPage: 24,
      currentPage: 1,
      category: null,
      material: null,
      loading: false,
    };
  },
  mounted() {
    this.currentPage =
      typeof this.$route.query.page != "undefined" ? this.$route.query.page : 1;
    this.category =
      typeof this.$route.query.category != "undefined"
        ? this.$route.query.category
        : "";
    this.material =
      typeof this.$route.query.material != "undefined"
        ? this.$route.query.material
        : "";
    this.fetchData();
    this.$store.dispatch("our-product/getTeaAccessoriesCategories");
  },
  methods: {
    fetchData() {
      let data = {
        size: this.perPage,
        page: this.currentPage,
        material: this.material,
        category: this.category,
      };
      this.$router.push({
        path: "/our-products/tea-accessories",
        query: data,
      });
      this.$store.dispatch("our-product/getTeaAccessories", data);
    },
    changeEv() {
      this.currentPage = 1;
    },
    clearSingleItem() {
      this.$store.commit("our-product/CLEAR_SINGLE_ACCESSORY");
    },
  },
  computed: {
    pageData() {
      if (this.$store.state["our-product"].teaAccessoriesPage != null) {
        return this.$store.state["our-product"].teaAccessoriesPage;
      }
    },
    filteredItems() {
      if (this.$store.state["our-product"].teaAccessoriesPage != null) {
        return this.$store.state["our-product"].teaAccessoriesPage.data;
      }
    },
    categoryData() {
      if (this.$store.state["our-product"].teaAccessoriesCategories != null) {
        return this.$store.state["our-product"].teaAccessoriesCategories
          .teawareCategories;
      }
    },
    materialData() {
      if (this.$store.state["our-product"].teaAccessoriesCategories != null) {
        return this.$store.state["our-product"].teaAccessoriesCategories
          .teawareMaterials;
      }
    },

    pageCount() {
      if (this.$store.state["our-product"].teaAccessoriesPage != null) {
        return this.$store.state["our-product"].teaAccessoriesPage.total_items;
      }
    },
  },
  components: {
    BannerTypeProduct,
    KinesisContainer,
    KinesisElement,
  },

  watch: {
    $route(to) {
      this.size = 24;
      if (
        typeof to.query.category != "undefined" &&
        typeof to.query.material != "undefined"
      ) {
        this.loading = true;
        this.currentPage = to.query.page;
        this.category = to.query.category;
        this.material = to.query.material;
        window.scrollTo(0, 500);
        this.fetchData();
      }
    },

    filteredItems(val) {
      if (typeof val != "undefined") {
        this.loading = false;
      } else {
        this.loading = true;
      }
    },
    currentPage: function (newVal, oldVal) {
      if (newVal) {
        this.fetchData();
      }
    },
  },
};
